import { useEffect, useRef } from 'react';

export const usePrevious = (value, defaultValue) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return (ref.current) ? ref.current : defaultValue;
}